import { getContext } from '@fiverr-private/fiverr_context';
import { PAGE_NAME } from '../../constants';

export const transformExperimentsData = (experimentsData = {}) =>
    Object.entries(experimentsData)
        .map((val) => `${val[0]}=${val[1]}`)
        .join();

export const gigContextEnrichment = ({
    collections,
    setCollections,
    currency,
    source = 'TagPage',
    activeExperiments,
}) => {
    const { isTouch, userId, pageCtxId } = getContext();

    return {
        collectProps: {
            collections,
            onUpdateCollections: setCollections,
            isLoggedIn: !!userId,
            modalCustomName: PAGE_NAME,
        },
        impressionEnrichment: {
            gigData: {
                local_experiments: transformExperimentsData(activeExperiments),
            },
            listings: {
                page_ctx_id: pageCtxId,
            },
        },
        context: {
            sourcePage: PAGE_NAME,
            sourceComponent: source,
            viewportType: 'tags.show',
            controllerAction: 'tags#show',
            userId,
            pageCtxId,
            currency,
        },
        isTouch,
    };
};
